<table class="table" style="background: #fff;">
  <thead>
    <tr>
      <th style="width: 65%">
        DESCRIPTION
      </th>
      <th class="align-right" style="width: 17%">
        PRICE
      </th>
      <th class="align-right" style="width: 7%">
        QTY
      </th>
      <th class="align-right" style="width: 11%">
        SUBTOTAL
      </th>
    </tr>
  </thead>
  <tbody>
    <tr class="product-wrapper" *ngFor="let cd of cartDetails">
      <td class="expand align-left summary-description">
        <span class="product-title">{{cd.itemDescription}}<span *ngIf="cd.stockCode.toLowerCase() === 'donation'"> FOR {{ currentUserModel.isAU ? 'FNPW' : 'TREE THAT COUNT' }}</span></span>
        <!-- <span> Stock Code: {{cd.stockCode}}</span>
        <span> Status: {{cd.status}}</span> -->
        <div class="row product-secondary-wrapper">
          <div *ngIf="cd.stockCode.toLowerCase() !== 'donation'">
              <span class="light-text">STOCK CODE:&nbsp;</span>
              <span>{{cd.stockCode}}</span>
              <span class="divider-wrapper">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
              <span class="light-text">STATUS:&nbsp;</span>
              <span>{{cd.status}}</span>
          </div>
          <div *ngIf="cd.stockCode.toLowerCase() === 'donation'">
              <span>
                On behalf of Dicker Data and {{ currentUserModel.isAU ? 'FNPW' : 'TTC' }} thank you for your contribution to our bushfire recovery initiative
              </span>
          </div>
        </div>
        <div class="row result-additional-info">
            <div *ngIf="cd.freightPolicy ==='Q'" class="bundle-wrapper text-font" mat-raised-button>
                <img class="center" src="../images/new_ui/weight-black.png">
            </div>
            <div *ngIf="cd.salesType =='K'" class="bundle-wrapper text-font">
                <img class="center" src="../images/new_ui/bundle.png">
                <div class="bold-text center">BUNDLE</div>
            </div>
            <div *ngIf="cd.stockCode.toLowerCase() === 'donation'" class="promotion-wrapper text-font">
                <img class="center" src="../images/new_ui/donation.png">
                <div class="bold-text center">DONATION</div>
            </div>
         </div>
      </td>
      <td class="align-right expand">
        <span>
          {{cd.unitCost | currency:'AUD':'symbol-narrow':'.2-2'}}
          <div class="general-info-icon" style="margin-left:5px;" *ngIf="cd.billingFrequency == '1'">
            <div class="master-tooltip" title="MONTHLY">M</div>
          </div>

          <div class="general-info-icon" style="margin-left:5px;" *ngIf="cd.billingFrequency == 'Y'">
            <div class="master-tooltip" title="YEARLY">Y</div>
          </div>
        </span>
      </td>
      <td class="align-right expand">
        <span>{{cd.quantity}}</span>
      </td>
      <td class="align-right expand">
        <span>{{cd.subTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
      </td>
    </tr>
    <tr class="table-divider">
      <td colspan="2"></td>
      <td colspan="2"></td>
    </tr>
    <tr class="total-row">
      <td class="align-right expand notopborder" colspan="2" style="padding:0px 12px">
        Freight (Ex GST)
      </td>
      <td class="align-right expand notopborder" colspan="2" style="padding:0px 12px">
        <span *ngIf="checkoutSummary?.freight?.isAirQuoteRequired">
            Manual Air Quote Required
        </span>
        <span *ngIf="!checkoutSummary?.freight?.isAirQuoteRequired && checkoutSummary?.freight?.isQuoteRequired">
            Manual Quote Required
        </span>
        <span *ngIf="!checkoutSummary?.freight?.isAirQuoteRequired && !checkoutSummary?.freight?.isQuoteRequired">
            {{checkoutSummary?.freight?.freightCharge | currency:'AUD':'symbol-narrow':'.2-2'}}
        </span>
      </td>
    </tr>
    <tr>
      <td colspan="2" class="align-right expand notopborder" style="padding:0px 12px">
        Transaction Surcharge
      </td>
      <td colspan="2" style="padding:0px 12px" class="align-right expand notopborder">{{checkoutSummary?.payment?.transactionSurcharge}}</td>
    </tr>
    <tr class="total-row">
      <td colspan="2" class="align-right expand" style="font-weight: bold">
        Total (Ex GST)
      </td>
      <td colspan="2" class="align-right expand">{{subTotal | currency:'AUD':'symbol-narrow':'.2-2'}}</td>
    </tr>
    <tr class="total-row">
      <td style="padding:0px 12px 12px 12px" colspan="2" class="align-right expand notopborder" *ngIf="checkoutSummary?.shippingAddress?.isAu">GST (10%)</td>
      <td style="padding:0px 12px 12px 12px" colspan="2" class="align-right expand notopborder" *ngIf="!checkoutSummary?.shippingAddress?.isAu">GST (15%)</td>
      <td style="padding:0px 12px 12px 12px" colspan="2" class="align-right expand notopborder">{{checkoutSummary?.payment?.cartTax}}</td>
    </tr>

    <tr class="total-row" style="background: #f5f5f5;">
      <td colspan="2" class="align-right" style="font-weight:bold">
        Total (Inc GST)
      </td>
      <td colspan="2" style="font-weight: 300;
      font-size: 18px;
      line-height: normal;" class="align-right">{{checkoutSummary?.payment?.totalAmount}}</td>
    </tr>
  </tbody>
</table>